module.exports = __webpack_public_path__ + "img/cluster-44-advert.5176162e.svg";